/* eslint-disable prefer-destructuring */
import { useMemo } from 'react';
import { useRouter } from 'next/router';

import { defaultLocale, getCountryFromMarket } from 'utils/translations';
import { localeRegex } from 'utils/i18n';
import { getRealLanguage } from 'utils/helpers';

export type LocaleObject = {
  locale: string;
  country: string;
  language: string;
  market: string;
  isoLocale: string;
  realLanguage: string;
};

export function parseLocale(locale: string): LocaleObject {
  const parsed: LocaleObject = {
    locale: '',
    country: '',
    language: '',
    market: '',
    isoLocale: '',
    realLanguage: '',
  };
  // si el locale no es valido(en_US), retorna parsed con los valores a null

  if (locale && !localeRegex.test(locale)) {
    console.warn('useLocale: invalid locale', locale);
    const splitDefault = defaultLocale.split('_') as [string, string];
    parsed.locale = defaultLocale;
    parsed.country = splitDefault[1];
    parsed.market = getCountryFromMarket(splitDefault[1]);
    parsed.language = splitDefault[0];
    parsed.isoLocale = `${getRealLanguage(splitDefault[0])}-${splitDefault[1]}`;
    parsed.realLanguage = getRealLanguage(splitDefault[0]);
  }
  if (locale && localeRegex.test(locale)) {
    const split = locale.split('_') as [string, string];
    parsed.locale = locale;
    parsed.country = split[1];
    parsed.market = getCountryFromMarket(split[1]);
    parsed.language = split[0];
    parsed.isoLocale = `${getRealLanguage(split[0])}-${split[1]}`;
    parsed.realLanguage = getRealLanguage(split[0]);
  }

  return parsed;
}

export function useLocale() {
  const { locale } = useRouter();

  const parsedLocale = useMemo(() => parseLocale(locale), [locale]);

  return parsedLocale;
}
